import { Splide } from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export const ticker = () => {
    const $ = jQuery;

    const wrappers = $('.walk-of-fame.ticker .ticker-wrapper');

    if (wrappers.length !== 0) {
        wrappers.each((i, wrapper) => {
            const ticker = new Splide( wrapper, {
                type   : 'loop',
                drag   : 'free',
                focus  : 'center',
                perPage: 2,
                gap: '1rem',
                pagination: false,
                arrows: false,
                autoScroll: {
                    speed: 1
                },
                mediaQuery: 'min',
                breakpoints: {
                    600: {
                        perPage: 3,
                        gap: '2rem'
                    },
                    768: {
                        perPage: 4
                    },
                    992: {
                        perPage: 6,
                    },
                    1200: {
                        perPage: 8,
                        gap: '6rem'
                    }
                }
            } );
    
            ticker.mount( { AutoScroll, Intersection } );
        });
    }

    

    const homeHero = $('.carousel-hero');

    if (homeHero.length === 1) {
        const carousel = new Splide( homeHero[0], {
            type: 'loop',
            interval: 6000,
            arrows: false,
            pagination: true,
            pauseOnHover: false,
            pauseOnFocus: false
        } );

        carousel.on( 'pagination:updated', function (data, prev, curr) {
            prev.button.classList.remove('animate');
            curr.button.classList.add('animate');
        } );

        carousel.on( 'pagination:mounted', function ( data ) {
            data.items.forEach( function ( item ) {
                item.button.innerHTML = '<span></span>';
            } );
          } );

        carousel.on( 'mounted', function () {
            carousel.Components.Autoplay.play();
        } );

        const button = $('#carousel-control');

        if (button.length === 1) {
            button[0].addEventListener('click', () => {
                const Autoplay = carousel.Components.Autoplay;
                const animatingBullet = $('#home-hero .splide__pagination__page.animate span');
                
                if (Autoplay.isPaused()) {
                    button[0].classList.add('playing');
                    Autoplay.play();
                    animatingBullet[0].style.animationPlayState = 'running';
                } else {
                    button[0].classList.remove('playing');
                    Autoplay.pause();
                    animatingBullet[0].style.animationPlayState = 'paused';
                }
            });
        }

        carousel.mount();
    }
};